module.exports = __webpack_public_path__ + "static/img/boothStep6.ee4f278f.jpg";